<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>Neue Lieferung vom Kunden</modal-header>
            <modal-content>
                <form-datepicker id="delivery_at" label="Eingangsdatum" name="delivery_at" v-model:date="form.delivery_at" :error="form.errors.delivery_at" />

                <form-input id="amount" :label="'Stückzahl (max '+maxIncomingQty+' Stück)'" name="amount" v-model="form.amount"
                            :error="form.errors.amount" autocomplete="off"/>

                <form-text id="comment" label="Kommentar" name="comment" v-model="form.comment" :error="form.errors.comment"></form-text>

                <form-select id="client_complaint_id" label="Reklamationsnummer" name="client_complaint_id"
                             :options="clientComplaintOptions" v-model="form.client_complaint_id"
                             :error="form.errors.client_complaint_id"/>

                <form-select id="admin_user_id" label="Bearbeitet von" name="admin_user_id"
                             :options="adminUserOptions" v-model="form.admin_user_id"  :error="form.errors.admin_user_id" />

            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}">Speichern</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import {useForm} from '@inertiajs/vue3';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormText from '@partfactory/Shared/Form/FormText';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';

export default {
    name: 'IncomingGoodsClientModal',
    components: {
        FormDatepicker,
        FormText, FormInput, FormSelect, FormButton, ModalActions, Modal, ModalContent, ModalHeader
    },
    props: {
        incomingGoodsClient: Object,
        askForQuote: Object,
        adminUsers: Object,
    },
    emit: ['closeDialog'],
    data() {
        const currentDate = this.$moment(new Date, 'YYYY-MM-DD').format('YYYY-MM-DD');

        const form = useForm({
            delivery_at: this.incomingGoodsClient?.delivery_at ? this.incomingGoodsClient?.delivery_at : currentDate,
            amount: this.incomingGoodsClient?.amount ? this.incomingGoodsClient?.amount : null,
            comment: this.incomingGoodsClient?.comment ? this.incomingGoodsClient?.comment : null,
            admin_user_id: this.incomingGoodsClient?.admin_user_id ? this.incomingGoodsClient?.admin_user_id : this.$page.props.user.id,
            client_complaint_id: this.incomingGoodsClient?.client_complaint_id ? this.incomingGoodsClient?.client_complaint_id : null,

        });

        return {form};
    },
    computed: {
        clientComplaintOptions() {
            let clientComplaints = [];
            this.askForQuote.client_complaints.forEach(clientComplaint => {
                clientComplaints.push({value: clientComplaint.id, text: clientComplaint.complaint_number});
            });

            return clientComplaints;
        },
        adminUserOptions() {
            let adminUserOptions = [];
            this.adminUsers.forEach(adminUser => {
                adminUserOptions.push({value: adminUser.id, text: adminUser.name});
            });

            return adminUserOptions;
        },
        maxIncomingQty() {
            let maxIncomingQty = 0;
            this.askForQuote?.client_complaints?.forEach((incoming) => {
                maxIncomingQty += incoming.amount;
            });

            this.askForQuote?.incoming_goods_client?.forEach((outgoing) => {
                maxIncomingQty -= outgoing.amount;
            });
            return maxIncomingQty;
        },
    },
    methods: {
        submit() {
            if (this.incomingGoodsClient) {
                this.form
                    .transform(data => ({
                        ...data,
                        _token: this.$page.props.csrf_token,
                    }))
                    .patch(this.$$route('ask-for-quote.delivery.incoming-goods-client.patch', {'askForQuote': this.askForQuote.id, 'incomingGoodsClient': this.incomingGoodsClient.id}), {
                        onSuccess: () => this.$emit('closeDialog'),
                    });
            } else {
                this.form
                    .transform(data => ({
                        ...data,
                        _token: this.$page.props.csrf_token,
                    }))
                    .post(this.$$route('ask-for-quote.delivery.incoming-goods-client', {'askForQuote': this.askForQuote.id}), {
                        onSuccess: () => this.$emit('closeDialog'),
                    });
            }

        },
    },
};
</script>
